import { useNavigate, useParams } from "react-router-dom";
import { useApp, useUpdateApp } from "../../hooks/useApps";
import { useAuthStore } from "../../store/auth.store";
import { AppForm } from "./AppForm";
import { AppUserAccess } from "./AppUserAccess";

export function AppDetail() {
  const { appId } = useParams<{ appId: string }>();
  const navigate = useNavigate();
  const { data: app, isLoading, error } = useApp(appId);
  const isAdmin = useAuthStore((s) => s.user?.isPanelAdmin === true);
  const updateApp = useUpdateApp(appId!);

  if (isLoading) return <p className="muted">Loading…</p>;
  if (error || !app) return <p className="error-text">App not found</p>;

  return (
    <>
      <div className="page-header">
        <div>
          <h2>{app.name}</h2>
          <div className="muted">{app.url}</div>
        </div>
      </div>

      {isAdmin && (
        <>
          <AppForm
            initial={app}
            submitLabel="Save"
            onSubmit={async (input) => {
              await updateApp.mutateAsync(input);
            }}
            onCancel={() => navigate("/apps")}
          />
          <AppUserAccess appId={app.id} />
          <p className="muted" style={{ fontSize: 12, marginTop: 12 }}>
            Created {new Date(app.createdAt).toLocaleString()}
          </p>
        </>
      )}
    </>
  );
}
